module.exports = __webpack_public_path__ + "img/Sound Icon - charcoal.af987efb.svg";